
// firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Firebase 初期化
const app = initializeApp(firebaseConfig);

// Auth と Firestore の取得
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

// 認証情報の永続化をローカルストレージに設定
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // 成功時は特に追加処理なし
    console.log("Firebase Auth persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set auth persistence:", error);
  });

const messaging = getMessaging(app);

export { auth, provider, messaging };
